import React from 'react'

import TimePicker from '@components/SearchForm/TimePicker'
import bem from '@lib/bem'
import { useTranslation } from '@lib/i18n'

interface TimePickerSetProps {
  returnStartTime: boolean
  returnEndTime: boolean
}

const TimePickerSet = ({ returnStartTime, returnEndTime }: TimePickerSetProps) => {
  const { t } = useTranslation()

  return (
    <div className={bem('search-form', 'times')}>
      <div className="search-form__compound-time-select">
        {returnStartTime && <TimePicker name="returnStartTime" label={t('searchBar.returnStartTimeLabel')} />}
        {returnEndTime && <TimePicker name="returnEndTime" label={t('searchBar.returnEndTimeLabel')} />}
      </div>
    </div>
  )
}

export default TimePickerSet
